import { useState } from 'react'
import { useAppItemRecommendations } from 'components/pages/CartPage/ItemRecommendations/types/query'
import RecommendationGroup from 'components/pages/CartPage/ItemRecommendations/RecommendationGroup'
import AddItemModal from 'components/ItemModal/AddItemModal'
import { LocationWorkStatus } from 'global-graphql-types'

type Props = {
  cartUuid: string
}

export default function ItemRecommendations({ cartUuid }: Props) {
  const [itemIdModal, setItemIdModal] = useState<number>()
  const [modalVisible, setModalVisible] = useState<boolean>()

  const { data, refetch } = useAppItemRecommendations({
    variables: {
      uuid: cartUuid,
      count: 9
    }
  })

  const openModal = (id: number) => {
    setItemIdModal(id)
    setModalVisible(true)
  }
  if (!data) return null
  const cart = data.currentCart

  if (!cart) return null
  if (!cart.location) return null

  const items = cart.itemRecommendations
  if (items.length <= 0) return null

  const canOrder =
    cart.location.workStatus !== LocationWorkStatus.WorkNotStarted &&
    cart.location.workStatus !== LocationWorkStatus.WorkPaused &&
    cart.location.allowOrders

  return (
    <>
      <div>
        <p className="mt-6 text-lg font-bold text-orange-700 sm:text-2xl">
          Anything else?
        </p>
        <RecommendationGroup items={items} openModal={openModal} />
      </div>
      {modalVisible && itemIdModal && (
        <AddItemModal
          canOrder={canOrder}
          closeModal={() => setModalVisible(false)}
          id={itemIdModal}
          locationId={cart.location.id}
          modalIsOpen={modalVisible}
          onAdd={refetch}
          source="web_cart_upsell"
          upsell
        />
      )}
    </>
  )
}
